
export class ExpertPaymentBuilder {
    constructor() {
        this.expertPayment = {};
    }

    setId(id){
        this.expertPayment.id = id;
        return this;
    }

    setName(name){
        this.expertPayment.name = name;
        return this;
    }

    setEmail(email){
        this.expertPayment.email = email;
        return this;
    }

    setBalance(balance){
        this.expertPayment.balance = balance;
        return this;
    }

    setLifetimeEarning(lifetimeEarning){
        this.expertPayment.lifetimeEarning = lifetimeEarning;
        return this;
    }

    setActions(actions){
        this.expertPayment.actions = actions;
        return this;
    }

    build(){
        return this.expertPayment;
    }
}
